module.exports = __webpack_public_path__ + "img/slide11-piece-16.b71578a8.png";